import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';

@Component({
    selector: 'app-financial-assets-en-v2',
    templateUrl: './financial-assets-en-v2.component.html',
    styleUrls: ['./financial-assets-en-v2.component.css'],
    standalone: false
})
export class FinancialAssetsEnV2Component implements OnInit, OnChanges {
  @Input() printActive: boolean
  @Input() returnData: any
  @Input() isSinglePageReturn: boolean
  shareDebenture = [];
  sanchayapatra = [];
  fdrInfo = [];
  dpsInfo = [];
  loanInfo = [];
  providentFund = [];
  otherInfo = [];
  bankInfo = [];

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.shareDebenture = [];
    this.sanchayapatra = [];
    this.fdrInfo = [];
    this.dpsInfo = [];
    this.loanInfo = [];
    this.providentFund = [];
    this.otherInfo = [];
    this.bankInfo = [];

    this.returnData?.headSummery?.assetsAndLiabilities?.forEach(item=>{
      if(item.secondSubTypeKey === 'share_debenture_etc' && item.detailsOfAL?.length && item.detailsOfAL?.[0]?.type != ''){
        this.shareDebenture = this.shareDebenture.concat(item.detailsOfAL)
      }
      if(item.secondSubTypeKey === 'savings_certificate_bonds_and_other_government_securities' && item.detailsOfAL?.length && item.detailsOfAL?.[0]?.dateOfIssue != null){
        this.sanchayapatra = this.sanchayapatra.concat(item.detailsOfAL)
      }
      if(item.secondSubTypeKey === 'fix_deposits_term_deposits_and_dps' && item.detailsOfAL?.length && item.detailsOfAL?.[0]?.name != ''){
        this.fdrInfo = this.fdrInfo.concat(item.detailsOfAL)
      }
      if(item.secondSubTypeKey === 'dps' && item.detailsOfAL?.length && item.detailsOfAL?.[0]?.name != ''){
        this.dpsInfo = this.dpsInfo.concat(item.detailsOfAL)
      }
      if(item.secondSubTypeKey === 'loans_given_to_others' && item.detailsOfAL?.length && item.detailsOfAL?.[0]?.relatedIN != ''){
        this.loanInfo = this.loanInfo.concat(item.detailsOfAL)
      }
      if(item.secondSubTypeKey === 'provident_fund_and_other_fund' && item.detailsOfAL?.length && item.detailsOfAL?.[0]?.relatedIN != ''){
        this.providentFund = this.providentFund.concat(item.detailsOfAL)
      }
      if(item.secondSubTypeKey === 'other_financial_assets' && item.detailsOfAL?.length && item.detailsOfAL?.[0]?.type != ''){
        this.otherInfo = this.otherInfo.concat(item.detailsOfAL)
      }
      if(item.secondSubTypeKey === 'banks_cards_and_other_electronic_cash' && item.detailsOfAL?.length && item.detailsOfAL?.[0]?.type != ''){
        this.bankInfo = this.bankInfo.concat(item.detailsOfAL)
      }
    })
  }

  isViewReady() {
    return this.shareDebenture.length || this.sanchayapatra.length || this.fdrInfo.length || this.dpsInfo.length || this.loanInfo.length || this.providentFund.length || this.otherInfo.length
  }

}
